// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAddressArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeAddressArkFragment on OpenapiAddress {
    city
    country
    line1
    line2
    postal_code
    state
  }
`;

export const stripeAddressArkFragment: StripeAddressArkFragmentDocument = doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAddressArkFragmentData = {
  readonly __typename: 'OpenapiAddress';
  readonly city: string | null;
  readonly country: string | null;
  readonly line1: string | null;
  readonly line2: string | null;
  readonly postal_code: string | null;
  readonly state: string | null;
};

export type StripeAddressArkFragmentVariables = Exact<{[key: string]: never}>;

const stripeAddressArkFragmentPermissions = {} as const;

doc.permissions = stripeAddressArkFragmentPermissions;

export type StripeAddressArkFragmentPermissions = V1PermissionToken<
  typeof stripeAddressArkFragmentPermissions
>;

export type StripeAddressArkFragmentDocument = GraphQlDocument<
  StripeAddressArkFragmentData,
  StripeAddressArkFragmentVariables,
  StripeAddressArkFragmentPermissions
>;
